/* eslint-disable default-param-last */
import { SET_HAS_SHARED, SET_PURCHASE_PEOPLE, SET_REFERAL_INFO, SET_UNCOVERED_FRIENDS, } from "../actions/types";
const initState = {
    referalInfo: {
        PRICE: "",
        email: "",
        email_link: "",
        facebook_link: "",
        messenger_link: "",
        name: "",
        possible_credits: "",
        promoCode: "",
        purchases: 0,
        purl_link: "",
        quiz_completions: 0,
        referral_credits_earned: "",
        sms_link: "",
        unconverted_friends: [],
        ctaCopy: "",
        purchase_people: [],
        stored: [],
    },
    hasShared: false,
    unconverted_friends: [],
    purchase_people: [],
    stored: [],
};
function referalReducer(state = initState, action) {
    switch (action.type) {
        case SET_REFERAL_INFO: {
            return {
                ...state,
                referalInfo: action.payload,
            };
        }
        case SET_UNCOVERED_FRIENDS: {
            return {
                ...state,
                referalInfo: { ...state.referalInfo, unconverted_friends: action.payload },
            };
        }
        case SET_PURCHASE_PEOPLE: {
            return {
                ...state,
                referalInfo: { ...state.referalInfo, purchase_people: action.payload },
            };
        }
        case SET_HAS_SHARED: {
            return {
                ...state,
                hasShared: action.payload,
            };
        }
        default:
            return state;
    }
}
export default referalReducer;
